import { Access } from "../../../access/types.ts";

export const AzureAccesses = {
  resource: Access({
    description: "Roles for an Azure resource",
    label: "Resource within Azure",
    maturity: "ga",
    delegation: {},
    generated: {},
    parameters: {
      subscription: {
        type: "dynamic",
        label: "Subscription",
        description: "Subscription ID",
        isPreselect: true,
      },
      subscriptionLabel: {
        type: "generated",
        label: "Subscription label",
        description: "Label of the subscription",
        optional: true,
      },
      resource: {
        type: "dynamic",
        label: "Resource within Azure",
        description: "Resource ID",
        waitForInput: true,
      },
      resourceType: {
        type: "generated",
        label: "Resource type",
        description: "Type of the resource",
        optional: true,
      },
      role: {
        type: "dynamic",
        label: "Role",
        description: "Role ID",
      },
      roleName: {
        type: "generated",
        label: "Role name",
        description: "Name of the role",
      },
      principalId: {
        type: "generated",
        label: "Principal ID",
        description: "ID of the principal to assign the role to",
      },
      roleAssignmentId: { type: "generated", label: "assignment id of role" },
    },
    render: { locator: "subscription", policy: "role" } as const,
  }),
};

export type AzureAccesses = typeof AzureAccesses;
export type AzureAccess = AzureAccesses[keyof AzureAccesses];

export type AzureResourceAccess = AzureAccesses["resource"];
